import React, { Component } from 'react';
import { CheckSquareOutlined, CloseSquareOutlined } from '@ant-design/icons';

export default class RendererBoolean extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.valueAsIcon(),
        };
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
    }

    btnClickedHandler = () => {
        if(this.props.clicked){
            this.props.clicked(this.props.data);
        }
    }

    valueAsIcon() {
        if (this.props.value || this.props.value > 0) {
            return <CheckSquareOutlined onClick={this.btnClickedHandler} style={{ color:'#008000', fontSize: '16px' }} />
        } else if (this.props.value || this.props.value == 0) {
            return <CloseSquareOutlined onClick={this.btnClickedHandler} style={{ color:'#FF0000', fontSize: '16px' }}/>
        }
    }

    render() {
        return <span>
            {this.state.value}
        </span>;
    }
}
